import { InvoiceCreditNoteTypeLabel } from '@/core/domain/invoice/invoice/invoice.enums';
import { Select, SelectProps } from 'antd';

export default function SelectCreditNoteType(props: SelectProps) {
  const options = Object.keys(InvoiceCreditNoteTypeLabel).map((key) => ({
    value: key,
    label:
      InvoiceCreditNoteTypeLabel[
        key as keyof typeof InvoiceCreditNoteTypeLabel
      ],
  }));

  return (
    <Select
      {...props}
      options={options}
      style={{ ...props.style, width: '100%' }}
    />
  );
}
